import { render, staticRenderFns } from "./OrderCvsNumberResult.vue?vue&type=template&id=6295542b&scoped=true&"
import script from "./OrderCvsNumberResult.vue?vue&type=script&lang=ts&"
export * from "./OrderCvsNumberResult.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCvsNumberResult.vue?vue&type=style&index=0&id=6295542b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295542b",
  null
  
)

export default component.exports